export const OTP_RESEND_TIMEOUT_MILLISECONDS = 120000
export const ENCRYPTION_PASSPHRASE = 'ticketsms'
